//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { Enums } from "../../../../models/common"
import { OpDataType } from "../../../../models/core"


export class DataTypeClassBooleanRule implements IDataTypePanelRule {

    private static get dataTypeClass(): number { return Enums.DataTypeClass.Boolean }

    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(opDataType != null && opDataType.idDataTypeClass === DataTypeClassBooleanRule.dataTypeClass).promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                dataField: opDataType.idDataType.toString(),
                editorType: 'dxCheckBox',
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                editorOptions: {
                    value: _.first(data)
                },

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []
       
        return validationRules
    }

    //#endregion
}